import React, { useState, useEffect } from 'react';

const Home = () => {
  return <div>
    <p>😎 Welcome to my homepage 😎</p>
    <p>Please enjoy your stay</p>
  </div>
}

export default Home;